// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"265d877f","610":"793d0056","643":"e4e7a887","681":"7d0a2f43","714":"25483245","764":"44a35686"}[chunkId] + ".chunk.js";
};